export default "assets/images/5-stars-f0340b3a.svg";